import ApiService from '../../../shared/services/ApiService';

export default {

    getConnectedIntegrations () {
        return ApiService.get('integrations/connected');
    },

    disconnectPathmile() {
        return ApiService.get('integrations/pathmile/disconnect');
    }
}